module.exports = __webpack_public_path__ + "img/research_8.d0214ea8.png";